import { $axios } from '@/modules/http/axios'

async function filterTasks (phrase, loadingDate, unloadingDate, field = '*') {
  let criteria = null

  switch (field) {
    case 'numer_Przejazdu':
      criteria = '0000000000001'
      break
    case 'trasa':
      criteria = '0000000000010'
      break
    case 'nazwa_Firmy':
      criteria = '0000000000100'
      break
    case 'auto.plateNumber':
      criteria = '0000000001000'
      break
    case 'kierowcy.*.firstName':
      criteria = '0000000010000'
      break
    case 'kierowcy.*.surname':
      criteria = '0000000100000'
      break
    case 'semitrailer.plateNumber':
      criteria = '0000001000000'
      break
    case 'waluta':
      criteria = '0000010000000'
      break
    case 'stawka':
      criteria = '0000100000000'
      break
    case 'description1':
      criteria = '0001000000000'
      break
    case 'description2':
      criteria = '0010000000000'
      break
    case 'description3':
      criteria = '0100000000000'
      break
    case 'stoppages.*.acronym':
      criteria = '1000000000000'
      break
  }

  let url = `Task/Search?phrase=${phrase}&loadingDate=${loadingDate}&unloadingDate=${unloadingDate}&limit=100`;

  if (criteria) {
    url += `&criteria=${criteria}`
  }

  const tasks = (await $axios.get(url)).data

  return new Promise(resolve => {
    resolve(tasks)
  })
}

export { filterTasks }
